export class InternalServerError extends Error {}
